import _taggedTemplateLiteral from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from "styled-components";
import { size } from "../../../../../shared/constants";
export var SVG = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  margin-right: ", "px;\n  padding-top: ", "px;\n"])), size.xs3, size.xs2);